module.exports = __webpack_public_path__ + "img/1575460782.c8b8e0ae.jpg";